import styled from "@emotion/styled";
import {Imagefront} from "@syginc/imagefront-client";
import * as React from "react";
import {forwardRef, useCallback, useImperativeHandle, useRef} from "react";

import {uploadImage, UploadImageResult} from "./upload-image";

const ImageInputFile = styled.input`
    display: none;
`;

export interface ImageUploadInputRef {
    startUpload: () => void;
}

interface ImageUploadInputProps {
    imagefront: Imagefront;
    imageConvertType: string;
    onUploading?: () => void;
    onUploaded?: (uploadImageResult: UploadImageResult) => void;
}

export const ImageUploadInput = forwardRef<ImageUploadInputRef, ImageUploadInputProps>(
    function ImageUploadInput(props, ref) {
        const {imagefront, onUploaded, onUploading, imageConvertType} = props;

        const fileRef = useRef<HTMLInputElement>(null);
        useImperativeHandle(ref, () => ({
            startUpload: () => {
                fileRef.current?.click();
            },
        }));

        const onClick = useCallback(() => {
            const inputFile = fileRef.current;
            if (!inputFile) {
                return;
            }

            inputFile.value = "";
            inputFile.click();
        }, []);

        const onFileChange = useCallback(async () => {
            const inputFile = fileRef.current;
            if (!inputFile || !inputFile.files) {
                return;
            }

            if (onUploading) {
                onUploading();
            }
            inputFile.disabled = true;
            const result = await uploadImage(imagefront, inputFile.files[0], imageConvertType);
            if (onUploaded) {
                onUploaded(result);
            }
            inputFile.disabled = false;
        }, [imagefront, onUploading, imageConvertType, onUploaded]);

        return (
            <ImageInputFile
                type="file"
                accept=".jpg, .png"
                ref={fileRef}
                onClick={onClick}
                onChange={onFileChange}
            />
        );
    },
);
